import { Injectable } from '@angular/core';
import {
  DashboardResponse,
  UserSessionService
} from '@com-delta-idp/mnx-oauth';
import { CookieHelperService } from '@com-delta-idp/mnx-utils';
import {
  ACCOUNT,
  ACCOUNT_TYPE,
  NonLoggedInUser
} from '../../../constants/analytics.constants';
import {
  AnalyticsData,
  BaseAnalytics,
  User
} from '../../../interface/analytics.interface';
import { getUserData } from '../../utils/analytics.utils';

declare const window: Window & {
  adobeDataLayer: AnalyticsData[];
};

@Injectable({ providedIn: 'root' })
export class TripsAnalyticsService {
  private user: User = NonLoggedInUser;
  userUpdated = false;

  constructor(
    private userSession: UserSessionService,
    private helper: CookieHelperService
  ) {}

  private getLoggedInStatus(): boolean {
    const accountTypeCookie = this.helper.getCookieValue(ACCOUNT_TYPE);
    const accountCookie = this.helper.getCookieValue(ACCOUNT);
    return !!(accountTypeCookie || accountCookie);
  }

  setAdobeAnalytics<T extends BaseAnalytics>(data: T): void {
    if (!this.userUpdated && this.getLoggedInStatus()) {
      this.userSession
        .getUserSession()
        .subscribe((response: DashboardResponse) => {
          if (response) {
            this.user = getUserData(response);
            this.userUpdated = true;
          }
          this.pushtoAnalytics(data);
        });
    } else {
      this.pushtoAnalytics(data);
    }
  }

  pushtoAnalytics<T extends BaseAnalytics>(data: T): void {
    window.adobeDataLayer = window.adobeDataLayer || [];
    const dataWithUser: AnalyticsData = { ...data, user: this.user };
    window.adobeDataLayer.push(dataWithUser);
  }
}
